/**
 * 推送消息用户关联表请求接口
 * @author 王振宇
 * @since 2022-05-10
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_BYPUSHMESSAGEMEMBER_PAGE_LIST: function GET_BYPUSHMESSAGEMEMBER_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushMessageMember/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_BYPUSHMESSAGEMEMBER_LIST: function GET_BYPUSHMESSAGEMEMBER_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/byPushMessageMember/getList',
        method: 'get',
        params: data
      });
    },
    GET_BYPUSHMESSAGEMEMBER_INFO: function GET_BYPUSHMESSAGEMEMBER_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/byPushMessageMember/info',
        method: 'get',
        params: data
      });
    },
    SAVE_BYPUSHMESSAGEMEMBER: function SAVE_BYPUSHMESSAGEMEMBER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/byPushMessageMember/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_BYPUSHMESSAGEMEMBER: function UPDATE_BYPUSHMESSAGEMEMBER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/byPushMessageMember/update',
        method: 'put',
        data: data
      });
    },
    DELETE_BYPUSHMESSAGEMEMBER: function DELETE_BYPUSHMESSAGEMEMBER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/byPushMessageMember/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_BYPUSHMESSAGEMEMBER: function DELETE_BATCH_BYPUSHMESSAGEMEMBER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/byPushMessageMember/deleteBatch',
        method: 'delete',
        data: data
      });
    },
    PUSH_MEMBER_MESSAGE: function PUSH_MEMBER_MESSAGE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushMessage/memberPushMessage',
        method: 'post',
        data: data
      });
    }
  };
});